export enum StorageKeys {
  CRILIX_STORAGE_KEY = "CRILIX_DATA",
  CRILIX_TOKEN_KEY = "CRILIX_TOKEN",
}
